<style scoped>
.main {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
}
.legend {
  position: absolute;
  top: 20px;
  right: 20px;
  background-color: rgba(255, 255, 255, 0.3);
  border: none;
  padding: 10px;
  z-index: 1000;
}
.legend-item {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}
.legend-color {
  width: 20px;
  height: 20px;
  margin-right: 5px;
  border: 1px solid;
}
.map-component {
  z-index: 1;
}
.legend-label {
  font-size: 14px;
}
</style>

<template>
  <div class="main" ref="main">
    <l-map class="map-component" :zoom="zoom" :center="center">
      <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
      <slot></slot>
      <l-marker v-for="(marker, index) in incomingPositions" :key="marker.id" :lat-lng="marker.coordinates"
        @click="clickMarker(index)" :icon="createCustomMarker(marker.colors, marker.number)">
        <l-popup>
          {{ marker.countryFr }}
        </l-popup>
      </l-marker>
    </l-map>
    <div class="legend">
      <div v-for="(legendItem, index) in legendItems" :key="index" class="legend-item">
        <div class="legend-color" :style="{ backgroundColor: legendItem.color }"></div>
        <div class="legend-label">{{ legendItem.label }}</div>
      </div>
    </div>
  </div>
</template>

<script>

import { LMap, LTileLayer, LMarker, LPopup, LPolyline, LIcon } from '@vue-leaflet/vue-leaflet';
import 'leaflet/dist/leaflet.css';

export default {
  name: 'visual-map',
  props: {
    incomingPositions: { Type: Array },
    assignZoom: { default: function () { return 2 } },
    assignCenter: { default: function () { return 2 } }
  },
  components: { LMap, LTileLayer, LMarker, LPopup, LPolyline, LIcon },
  data: () => ({
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    zoom: 1,
    center: "",
    markerLatLng: [51.504, 2.333],
    draggable: true,
    visible: true,
    staticAnchor: [16, 37],
    legendItems: [
      { color: '#86B404', label: 'Captage' },
      { color: '#154985', label: 'Stockage' },
      { color: 'white', label: 'Transport' },
      { color: 'grey', label: 'Utilisation' },
      { color: 'black', label: 'Autres' },
    ]

  }),
  watch: {
    assignCenter: {
      handler(newVal) {
        if (newVal) {
          this.center = [newVal["Latitude"], newVal["Longitude"]];
          setTimeout(() => {
            this.zoom = 8;
          }, 1000);
        }
      },
      deep: true
    }
  },
  computed: {
  },
  created() {
    this.zoom = this.assignZoom
    this.center = [this.assignCenter["Latitude"], this.assignCenter["Longitude"]]
  },
  mounted() {
  },
  methods: {
    clickMarker(index) {
      const marker = this.incomingPositions[index];
      this.$emit("clickMarker", marker);
    },
    createCustomMarker(colors, number) {
      const markerSize = 20+(0.5*number);
      const centerX = markerSize / 2;
      const centerY = markerSize / 2;
      const radius = markerSize / 2;
      const strokeWidth = 2;
      let markerHtml = `<svg width="${markerSize}" height="${markerSize}" viewBox="0 0 ${markerSize} ${markerSize}" xmlns="http://www.w3.org/2000/svg">`;
      markerHtml += `<circle cx="${centerX}" cy="${centerY}" r="${radius - strokeWidth / 2}" fill="none" stroke="#fff" stroke-width="${strokeWidth}"/>`;
      if (colors.length === 1) {
        markerHtml += `<circle cx="${centerX}" cy="${centerY}" r="${radius - strokeWidth}" fill="${colors[0]}"/>`;
      } else {
        const segmentAngle = (360 / colors.length) * (Math.PI / 180);
        let startAngle = 0;
        for (let i = 0; i < colors.length; i++) {
          const endAngle = startAngle + segmentAngle;
          const startX = centerX + Math.cos(startAngle) * (radius - strokeWidth);
          const startY = centerY + Math.sin(startAngle) * (radius - strokeWidth);
          const endX = centerX + Math.cos(endAngle) * (radius - strokeWidth);
          const endY = centerY + Math.sin(endAngle) * (radius - strokeWidth);
          markerHtml += `<path d="M${centerX},${centerY} L${startX},${startY} A${radius - strokeWidth},${radius - strokeWidth} 0 0 1 ${endX},${endY} Z" fill="${colors[i]}"/>`;
          startAngle = endAngle;
        }
      }
      markerHtml += '</svg>';
      const icon = L.divIcon({
        className: "custom-marker",
        iconAnchor: [centerX, centerY],
        html: markerHtml
      });

      return icon;
    }

  }



}


</script>
